require.register("handlebars-helper", function(exports, require, module){
  /* jshint ignore:start */

module.exports = (function() {
  Handlebars.registerHelper("color", LightenDarkenColor);
  Handlebars.registerHelper("increment", increment);
  Handlebars.registerHelper("math", math);
  Handlebars.registerHelper("concat", concat);

// courtesy of https://css-tricks.com/snippets/javascript/lighten-darken-color/
  function LightenDarkenColor(col, amt) {

    var usePound = false;

    if (col[0] == "#") {
      col = col.slice(1);
      usePound = true;
    }

    var num = parseInt(col, 16);

    var r = (num >> 16) + amt;

    if (r > 255) r = 255;
    else if (r < 0) r = 0;

    var b = ((num >> 8) & 0x00ff) + amt;

    if (b > 255) b = 255;
    else if (b < 0) b = 0;

    var g = (num & 0x0000ff) + amt;

    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    var color = (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    return color;
  }

  function increment(elem) {
    return parseInt(elem) + 1;
  }

  function math(lvalue, operator, rvalue) {
    lvalue = parseFloat(lvalue);
    rvalue = parseFloat(rvalue);

    return {
      "+": lvalue + rvalue,
      "-": lvalue - rvalue,
      "*": lvalue * rvalue,
      "/": lvalue / rvalue,
      "%": lvalue % rvalue
    }[operator];
  }

  function concat(arg1, arg2) {
    return arg1.concat(arg2.toString());
  }

  Handlebars.registerHelper("times", function(n, block) {
    let accum = "";
    for (let i = 0; i < n; ++i) accum += block.fn(i);
    return accum;
  });
})();

/* jshint ignore:end */

  
});

